import * as React from 'react'

const SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='23'
    fill='none'
    viewBox='0 0 18 23'
    {...props}
  >
    <path
      fill='#1D1D1F'
      fillRule='evenodd'
      d='M13.164 10.1c0-.684-.174-1.357-.505-1.957a4.1 4.1 0 0 0-1.388-1.478A4.127 4.127 0 0 0 5.758 7.67a4.06 4.06 0 0 0-.543 3.879 4.1 4.1 0 0 0 1.17 1.652 5.73 5.73 0 0 0-2.25 2.102 5.7 5.7 0 0 0-.83 2.957.81.81 0 0 0 .5.779.827.827 0 0 0 1.089-.459.8.8 0 0 0 .054-.32c0-1.082.433-2.12 1.203-2.885a4.12 4.12 0 0 1 2.905-1.195c1.09 0 2.134.43 2.905 1.195a4.07 4.07 0 0 1 1.203 2.885.81.81 0 0 0 .5.779.826.826 0 0 0 1.088-.459.8.8 0 0 0 .055-.32 5.7 5.7 0 0 0-.83-2.956 5.73 5.73 0 0 0-2.251-2.103 4.047 4.047 0 0 0 1.438-3.1M9.06 12.548c-.488 0-.964-.144-1.37-.412a2.45 2.45 0 0 1-.908-1.099 2.43 2.43 0 0 1 .535-2.667 2.47 2.47 0 0 1 2.686-.531c.45.185.835.499 1.106.901a2.436 2.436 0 0 1-.306 3.091 2.47 2.47 0 0 1-1.743.717'
      clipRule='evenodd'
    ></path>
    <path
      stroke='#1D1D1F'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M1.053 4.784C4.961 4.49 7.238 3.234 8.836 1.5a12.72 12.72 0 0 0 8.047 3.284c0 2.06.575 6.5-.823 10.19-1.41 3.72-4.852 6.529-7.04 6.529-2.14 0-5.585-2.486-7.204-6.78-1.116-2.947-.763-7.518-.763-9.94Z'
    ></path>
  </svg>
)

export default SvgIcon
